import { Box } from '@mui/material';
import React from 'react';

interface Props {
  size: number | undefined;
}

const Chip = ({ size }: Props): JSX.Element => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        ml: 3,
        mb: 3,
        height: '28px',
        width: '44px',
        borderRadius: 20,
        bgcolor: 'rgba(113, 196, 230, 0.4)'
      }}
    >
      {size}
    </Box>
  );
};

export default Chip;
